module.exports = __webpack_public_path__ + "img/page-031.7c064bb8.jpg";